import React, { FC } from 'react';
import { Link } from 'react-router-dom';


type Props = {
    href: string;
    src: string;
    width?: string;
    height?: string;
};


export const MenuIconButton: FC<Props> = ({ href, src, width, height }) => {
    if (href == '/map/my_list') {
        return (
            <>
                <a
                    style={{
                        width: width ? width : "34px",
                        height: height ? height : "34px",
                        marginLeft: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    href={href}
                >
                    <img src={src} />
                </a>

                <style jsx>{`
                    img {
                        width: ${width ? width : "34px"};
                    }
                `}</style>
            </>
        );
    }

    return (
        <>
            <Link
                style={{
                    width: width ? width : "34px",
                    height: height ? height : "34px",
                    marginLeft: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                to={href}
            >
                <img src={src} />
            </Link>

            <style jsx>{`
                img {
                    width: ${width ? width : "34px"};
                }
            `}</style>
        </>
    );
};
